import { convertToNormalCase } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import { m } from '@sohanscript/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { Link } from '@/components/link';
import { ReadmeContent } from './-components/readme-content';

export const Route = createFileRoute('/_main/readme/$repo')({
	component: ReadmePage,
	async loader({ context, params }) {
		await context.trpc.github.readme.ensureData({ repo: params.repo });
	},
	head({ params }) {
		return {
			meta: [{ title: convertToNormalCase(params.repo) }],
		};
	},
});

function ReadmePage() {
	const { repo } = Route.useParams();
	return (
		<>
			<div className="mb-8">
				<Link
					to="/"
					className="inline-flex items-center gap-1 text-primary/60 text-sm transition-colors hover:text-primary"
				>
					<Iconify icon="solar:arrow-left-linear" className="size-4" />
					{m.bc_home()}
				</Link>
			</div>
			<ReadmeContent repo={repo} />
		</>
	);
}
